/* eslint-disable react/jsx-key */
import React, { useEffect } from 'react';

import ModalManager from '../../components/ModalManager';
import { useModalManagerContext } from '../../components/ModalManager/ModalManagerContext';
import DelaySubscriptionStep1 from './DelaySubscriptionStep1';
import DelaySubscriptionStep2 from './DelaySubscriptionStep2';
import { useGlobalContext } from '../state/GlobalContext';
import ConfirmPauseModal from './ConfirmPauseModal';

const PauseMitigation: React.FC<{ subscription: Subscription }> = ({
  subscription,
}) => {
  const { isOpen, onClose, setData } = useModalManagerContext();
  const { customerPortalSettings } = useGlobalContext();
  const isBatchingEnabled = subscription?.BatchingConfiguration?.anchor;

  const isRescheduleHidden =
    customerPortalSettings?.hideReschedule ||
    customerPortalSettings?.hideEditNextOrderDate ||
    isBatchingEnabled;
  useEffect(() => {
    setData({ subscription });
  }, [setData, subscription]);

  const isPauseSuppressionEnabled = customerPortalSettings?.pauseSuppression;

  const configWithFlows = !isPauseSuppressionEnabled
    ? {
        firstStep: isRescheduleHidden ? (
          <ConfirmPauseModal />
        ) : (
          <DelaySubscriptionStep1 />
        ),
        flows: [<DelaySubscriptionStep2 />, <ConfirmPauseModal />],
      }
    : {
        firstStep: <DelaySubscriptionStep2 />,
        flows: [<ConfirmPauseModal />],
      };

  return (
    <ModalManager
      type="pause"
      config={configWithFlows}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
};

export default PauseMitigation;
